<template>
  <div class="contentCenter all">
    <div class="col-4">
      <h4>Mailbox Infra</h4>
    </div>
    <!-- Filter -->
    <div class="row">
      <div class="col-12 bg-light pb-2">
        <div class="d-flex col-5 my-1 mx-0 float-left">
          <FilterSystem
            class="float-center"
            :columns="filterFields"
            :reset="resetFilterSystem"
            :sort="sort"
            :dir="dir"
            :filterSystem="filtersSystem"
            :filterOldQuery="oldQuery"
            :key="filterkey"
            :menuPosition="'left'"
            :isLoading="loadingOwarmList"
            @callApi="filter($event)"
          />
          <div class="col-3 d-flex ">
          <div class=" d-flex justify-content-end  float-left align-items-center">
            <button class="btn btn-sm btn-danger mr-3 ml-3" @click="changeSearch(1)">Warmy</button>
            <button class="btn btn-sm btn-secondary" @click="changeSearch(2)">SmartLead</button>
          </div>
            
        </div>
        </div>
        
      </div>
    </div>
    <!-- End Filter -->

    <div class="row d-flex justify-content-between">
      <!-- Lista de valores promedios -->  
      <div class="d-flex flex-column table-responsive">
        <LoadingSpinner v-if="loadingOwarmList" />
        <div
          class="pt-3 px-2 d-flex justify-content-between bd-highlight mb-3"
          v-if="!loadingOwarmList && owarmList.list.length > 0"
        >
          <div class="bd-highlight">
            {{ $t("lang.label.results") }}:
            <small v-if="!total" class="ml-1 text-primary"
              >{{ $t("lang.search.calculating") }}...</small
            >
            <strong v-else>{{ total }}</strong>
            <button class="ml-2 btn btn-sm btn-primary" 
              @click="getDataToCsv()"
              :disabled="processingAllItems"
              >
              <span v-if="!processingAllItems">
                Download csv
              </span>
              <span v-else>Processing...</span>
          </button>
          </div>

          <!-- Paginador -->
          <div>
            <Pagination
              v-if="!loadingOwarmList"
              :total="total"
              :totalpage="owarmList.list.length"
              :model="model"
              color="primary"
              :limit="false"
              @changePage="changePage"
              :key="paginationkey"
            >
            </Pagination>
          </div>
          <div>.</div>
        </div>

        <!-- Data table -->
        <div
          v-if="!loadingOwarmList && owarmList.list.length > 0"
          class="table-sticky"
        >
          <Table
            v-if="!loadingOwarmList && owarmList.list.length > 0"
            :headers="headers4"
            :cols="cols4"
            :data="owarmList.list"
            :checkbox="false"
            :notselect="true"
            :model="model"
            @getOwarmStats="getOwarmStats"
            @goToClient="goToClient"
            @goToTarget="goToTarget"
            @runTest="runTest"
            @runManualTest="runManualTest"
          >
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  statusBadgeMixin,
  statusPointMixin,
  statusFeedNotificationsMixin,
  formattersMixin,
} from "@/_mixins/";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";
import LineChart from "@/components/Chart.vue";
import { adminService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import FilterSystem from "@/components/FilterSystem.vue";
import { mapState } from "vuex";
import { get } from "jquery";

export default {
  props: {
  },
  data() {
    return {
      processingAllItems: false,
      owarmListAllItems: [],
      oldQuery: "  ",
      dir: "",
      sort: "",
      resetFilterSystem: false,
      filterkey: 2233,
      filters: [],
      filterFields: [
        {
          name: "Email",
          name_: "client",
          type: "string",
          field: "cn.email",
        },
        {
          name: this.$t("lang.column.client"),
          name_: "client",
          type: "string",
          field: "cl.name",
        },
        {
          name: this.$t("lang.token.order_name"),
          name_: "target",
          type: "string",
          field: "t.name",
        },
        {
          name: 'Client Status',
          name_: "client_status_id",
          type: "list",
          list: [
            { id: "3", name: 'Preparing'},
            { id: "4", name: 'Active'},
            { id: "5", name: 'Standby'},
          ],
          field: "cl.client_status_id",
        },
        {
          name: 'Synced',
          name_: "warmup_active",
          type: "list",
          list: [
            { id: "1", name: 'Yes'},
            { id: "0", name: 'No'},            
          ],
          field: "weh.warmup_active",
        },     
        {
          name: 'Warning Status',
          name_: "warning_status",
          type: "list",
          list: [
            { id: "1", name: 'Yes'},
            { id: "0", name: 'No'},            
          ],
          field: "weh.status",
        },        
        {
          name: 'Email Status',
          name_: "owarm_status_id",
          type: "list",
          list: [
            { id: "1", name: 'Warming-up'},
            { id: "2", name: 'Active'},
            // { id: "3", name: 'Resting'},
            // { id: "4", name: 'Stopped'},
          ],
          field: "ow.owarm_status_id",
        },
        {
          name: this.$t("lang.token.order_status"),
          name_: "status",
          type: "list",
          list: [
            {
              id: "1",
              name: "Preparation",
            },
            {
              id: "2",
              name: "Inactive",
            },
            {
              id: "3",
              name: "Draft",
            },
            {
              id: "4",
              name: "Running",
            },
            {
              id: "5",
              name: "Archived",
            }
          ],
          field: "t.target_status_id"
        },
        {
          name: "Provider",
          name_: "Provider",
          type: "list",
          field: "cn.provider",
          list: [
            {
              id: "ews",
              name: "ews",
            },
            {
              id: "gmail",
              name: "gmail",
            },
          ],
        },
        {
          name: "Protocol",
          name_: "protocol",
          type: "list",
          field: "cn.send_method",
          list: [
            {
              id: "2",
              name: "SMTP",
            },
            {
              id: "3",
              name: "API",
            },
            {
              id: "4",
              name: "Browser",
            },
          ],
        },
        {
          name: "Warning Days",
          name_: "start_on_quantity",
          type: "number",
          field: "DATEDIFF(NOW(), ow.start_on)",
        },
        {
          name: "SPM CHK EWS",
          name_: "start_on_quantity",
          type: "number",
          field: "deliver_prc_ews",
          having: true,
        },
        {
          name: "SPM CHK GML",
          name_: "start_on_quantity",
          type: "number",
          field: "deliver_prc_gmail",
          having: true,
        },
      ],
      model: {
        manualTestFields:[]
      },
      client_id: 0,
      paginationkey: 0,
      total: 0,
      loadingOwarmList: true,
      cantPerPage: 100,
      accountSelected: false,
      headers4: [
        {
          // email
          label: this.$t("lang.label.email"),
          size: "200px",
          class: "overflowhide",
        },
        {
          //client
          label: this.$t("lang.label.client"),
          size: "150px",
          class: "overflowhide",
        },
        {
          //order
          label: this.$t("lang.token.order_name"),
          size: "200px",
          class: "overflowhide",
        },
        {
          //order status
          label: this.$t("lang.token.order_status"),
          size: "200px",
          class: "overflowhide",
        },
        {
          //start
          label: 'Warmup starting date', //this.$t("lang.column.start"),
          size: "140px",
          class: "overflowhide",
        },
        {
          //Synced
          label: "Synced",
          size: "80px",
          class: "overflowhide",
        },
        {
          //Status
          label: "Warmup status",
          size: "80px",
          class: "overflowhide",
        },
        {
          //Owarm_status_name
          label: "Status Name",
          size: "80px",
          class: "overflowhide",
        },
        {
          //Provider
          label: "Provider",
          size: "80px",
          class: "overflowhide",
        },
        {
          // protocol
          label: "Protocol",
          size: "200px",
          class: "overflowhide",
        },
        // {
        //   // avg_sent_last30
        //   label: "AVG SENT 30D",
        //   size: "200px",
        //   class: "overflowhide",
        // },
        // {
        //   // avg_step_1_last30
        //   label: "AVG STEP1 30D",
        //   size: "200px",
        //   class: "overflowhide",
        // },
        {
          //Delivrability
          label: "Deliverability",
          size: "60px",
          class: "overflowhide",
        },
        // {
        //   //DNS Score
        //   label: "DNS Score",
        //   size: "60px",
        //   class: "overflowhide",
        // },
        // {
        //   //ISP Score
        //   label: "ISP Score",
        //   size: "60px",
        //   class: "overflowhide",
        // },
        // {
        //   //Mailbox temperature
        //   label: "Mailbox temperature",
        //   size: "60px",
        //   class: "overflowhide",
        // },
        // { //Google Delivrability
        //   label: "Google",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "gmail-new-icon.png",
        // },
        // {
        //   //G Suite Delivrability
        //   label: "G Suite",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_google.png",
        // },
        // { //Outlook
        //   label: "Outlook",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_outlook.png"
        // },
        // {
        //   //OutlookBusiness
        //   label: "Outlook B.",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_ms365.png",
        // },
        // { //Yahoo
        //   label: "Yahoo",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_yahoo.png"
        // },
        // { // ICloud
        //   label: "ICloud",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_icloud.png"
        // },
        // { // Zoho
        //   label: "Zoho",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_zoho.svg"
        // },
        // {
        //   // Zoho Pro
        //   label: "Zoho Pro",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_zoho.svg",
        // },
        // {
        //   //SMTP
        //   label: "SMTP",
        //   size: "60px",
        //   class: "overflowhide",
        //   icon: "icon_email.png",
        // },
        // {
        //   //SPAM CHECK GMAIL
        //   label: "SPCHK GML",
        //   class: "overflowhide",
        //   icon: "icon_google.png",
        // },
        // {
        //   // SPAM CHECK EWS
        //   label: "SPCHK EWS",
        //   class: "overflowhide",
        //   icon: "icon_ms365.png",
        // },
        // {
        //   // SPAM CHECK DATE
        //   label: "SPCHK DATE",
        //   class: "overflowhide",
        // },
        {
          // RUN TEST
          label: "RUN TEST",
          class: "overflowhide",
        },
        {
          // RUN TEST
          label: "RUN MANUAL TEST",
          class: "overflowhide",
        },
        {
          // created
          label: "Email created",
          class: "overflowhide",
        },
      ],
      cols4: [
        [
          //email
          {
            value_label: "email",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "getOwarmStats",
            icon: "icon-bar-chart text-primary pr-2",
          },
        ],
        [
          //client
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToClient",
          },
        ],
        [
          //order
          {
            value_label: "target_name",
            value_emit: "target_id",
            class: "text-primary",
            type: "emit",
            emit: "goToTarget",
          },
        ],
        [
          //protocol
          {
            value: "target_status_name",
          },
        ],
        [
          //start
          {
            value: "start_on",
          },
        ],
        [
          //Synced
          {
            value: "warmup_active",
            show_text: "false",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "0",
                icon_true: "icon-cross text-danger",
              },
            ],
          },
        ],
        [
          //Status
          {
            value: "owarm_status",
            show_text: "false",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "0",
                icon_true: "icon-cross text-danger",
              },
            ],
          },
        ],
        [
          //owarm_status_name
          {
            value: "owarm_status_name",
          },
        ],
        [
          //provider
          {
            value: "provider",
            type: "image-icon",
          },
        ],
        [
          // protocol
          {
            value: "protocol",
          },
        ],
        // [
        //   // avg_sent_last30
        //   {
        //     value: "avg_sent_last30",
        //   },
        // ],
        // [
        //   // avg_step_1_last30
        //   {
        //     value: "avg_step_1_last30",
        //   },
        // ],
        [
          // deliverability
          {
            value: "deliverability",
          },
        ],
        // [
        //   // DNS score
        //   {
        //     value: "dns_score",
        //   },
        // ],
        // [
        //   // ISP score
        //   {
        //     value: "placement_score",
        //   },
        // ],
        // [
        //   // Mailbox temperature
        //   {
        //     value: "mailbox_temperature",
        //   },
        // ],
        // [ // Gmail
        //   {
        //     value: "gmail_deliverability",
        //     show_text : "false",
        //     type : "percentage"
        //   },
        // ],
        // [
        //   //G Suite
        //   {
        //     value: "gsuite_deliverability",
        //     show_text: "false",
        //     type: "percentage",
        //   },
        // ],
        // [ // Outlook
        //   {
        //     value: "outlook_deliverability",
        //     show_text : "false",
        //     type : "percentage"
        //   },
        // ],
        // [
        //   // OutlookBusiness
        //   {
        //     value: "ms365_deliverability",
        //     show_text: "false",
        //     type: "percentage",
        //   },
        // ],
        // [ // Yahoo
        //   {
        //     value: "yahoo_deliverability",
        //     show_text : "false",
        //     type : "percentage"
        //   },
        // ],
        // [ // ICloud
        //   {
        //     value: "icloud_deliverability",
        //     show_text : "false",
        //     type : "percentage"
        //   },
        // ],
        // [ // Zoho
        //   {
        //     value: "zoho_deliverability",
        //     show_text : "false",
        //     type : "percentage"
        //   },
        // ],
        // [
        //   // Zoho Pro
        //   {
        //     value: "zohoPro_deliverability",
        //     show_text: "false",
        //     type: "percentage",
        //   },
        // ],
        // [
        //   // SMTP
        //   {
        //     value: "smtp_deliverability",
        //     show_text: "false",
        //     type: "percentage",
        //   },
        // ],
        // [
        //   // SPAM CHECK GMAIL
        //   {
        //     value: "spam_check_gmail",
        //   },
        // ],
        // [
        //   // SPAM CHECK EWS
        //   {
        //     value: "spam_check_ews",
        //   },
        // ],
        // [
        //   // SPAM CHECK DATE
        //   {
        //     value: "spam_check_date",
        //   },
        // ],
        [
          // RUN TEST
          {
            value: "spam_check_test_status_id",
            btnId: "owarm_id",
            type: "btnAction",
            name: "Run Test",
            disabled:['1', '2'], //Valores con lo que el boton se mostrara deshabilitado.
            loading_data:['2'], //valores con lo que el boton mostrara como Loading...
            emit:"runTest"
          },
        ],
        [
          // RUN MANUALTEST
          {
            btnId: "owarm_id",
            type: "btnFieldAction",
            name: "Run Test",
            disabled:['1', '2'], //Valores con lo que el boton se mostrara deshabilitado.
            loading_data:['2'], //valores con lo que el boton mostrara como Loading...
            emit:"runManualTest"
          },
        ],
        [
          // EMAIL CREATED
          {
            value: "owarm_created",
          },
        ],
      ],
      openchart: false,
      owarmStats: [],
      owarmList: [],
      loadingOwarmList: true,
      loadOwarmStats: true,
      // owarmOptions: [
      //   {
      //     // [0]
      //     id: "inbox",
      //     label: "inbox",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "51, 204, 204",
      //     yAxisID: "y1",
      //     type: "bar",
      //   },
      //   {
      //     // [1]
      //     id: "spam",
      //     label: "spam",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "255,0,0",
      //     yAxisID: "y1",
      //     type: "bar",
      //   },
      //   {
      //     // [2]
      //     id: "missing",
      //     label: "missing",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "155, 155, 155",
      //     yAxisID: "y1",
      //     type: "bar",
      //   },
      //   {
      //     // [3]
      //     id: "replies",
      //     label: "replies",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "0, 128, 0",
      //     yAxisID: "y1",
      //     type: "line",
      //   },
      //   {
      //     id: "accounts",
      //     label: "accounts",
      //     role: ["1"],
      //     isDisabled: false,
      //     color: "0, 32, 255",
      //     yAxisID: "y2",
      //     type: "line",
      //   },
      // ],

      // multiaxisOwarm: {
      //   labels: [],
      //   datasets: [],
      //   options: {
      //     responsive: true,
      //     title: {
      //       display: true,
      //       text: this.$t("lang.label.activity"),
      //     },
      //     scales: {
      //       yAxes: [
      //         {
      //           type: "linear",
      //           id: "y1",
      //           stacked: true,
      //           position: "right",
      //           display: true,
      //           gridLines: {
      //             drawOnChartArea: false,
      //           },
      //           ticks: {
      //             beginAtZero: true,
      //           },
      //         },
      //         {
      //           type: "linear",
      //           id: "y2",
      //           position: "left",
      //           display: true,
      //           ticks: {
      //             beginAtZero: true,
      //           },
      //         },
      //       ],
      //       xAxes: [
      //         {
      //           type: "time",
      //           time: {
      //             unit: "day",
      //           },
      //           stacked: true,
      //           offset: true,
      //           gridLines: {
      //             display: false,
      //           },
      //         },
      //       ],
      //     },
      //     tooltips: {
      //       callbacks: {
      //         label: function (tooltipItem, data) {
      //           var label = data.datasets[tooltipItem.datasetIndex].label || "";

      //           if (label) {
      //             label += ": ";
      //           }

      //           var currentQty = tooltipItem.yLabel; // data.datasets[tooltipItem.datasetIndex].data;
      //           //  console.log(data.datasets);
      //           label += currentQty;
      //           // console.log(tooltipItem )
      //           // [0] inbox, [1] spam, [2] missing, [3] replies
      //           if ([0, 1, 3].includes(tooltipItem.datasetIndex)) {
      //             let total =
      //               parseInt(data.datasets[0].data[tooltipItem.index]) +
      //               parseInt(data.datasets[1].data[tooltipItem.index]);
      //             label += " ("
      //             label +=
      //               parseFloat(
      //                 (currentQty * 100) /
      //                 total
      //               ).toFixed(2) + "%)";
      //           } else if (tooltipItem.datasetIndex == 2) {
      //             let total =
      //               parseInt(data.datasets[0].data[tooltipItem.index]) +
      //               parseInt(data.datasets[1].data[tooltipItem.index]) +
      //               parseInt(data.datasets[2].data[tooltipItem.index]);
      //             label += " ("
      //             label +=
      //               parseFloat(
      //                 (currentQty * 100) /
      //                 total
      //               ).toFixed(2) + "%)";
      //           }

      //           return label;
      //         },
      //       },
      //     },
      //   },
      // },
    };
  },
  components: {
    LineChart,
    LoadingSpinner,
    Table,
    Pagination,
    FilterSystem,
  },

  mixins: [
    statusBadgeMixin,
    statusPointMixin,
    statusFeedNotificationsMixin,
    formattersMixin,
  ],

  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
    user() {
      return this.$store.state.authentication.user;
    },
  },

  created() {
    if (this.model.cantPerPage == undefined) {
      this.model.currentPage = 1;
      this.model.cantPerPage = this.cantPerPage;
    }    
    this.getOwarmStats();
  },

  methods: {
    download() {   
      const nameDocument = "report-mailbox-infra.csv";

      //Tomo headers desde simpleheader
      const headers = this.headers4.map(h => h.label);

      const fields = this.cols4.map( item => {
        const value = (item[0].value) ? item[0].value : item[0].value_label;
        return value;
      })

      const rows = this.owarmListAllItems.map( item => {
        return fields.map( col => {
          return item[col];
        }).map(v => `"${String(v !== undefined && v !== null ? v : '').replace(/"/g, '""')}"`).join(",");
      })

      const csv = `${headers.join(",")}\n${rows.join("\n")}`;
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", nameDocument);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      },
    runTest(owarm_id){
      adminService.spamCheckRunTest(owarm_id)
        .then( result => {

          if (result == 'ok') {
            this.owarmList.list.find(item => item.owarm_id == owarm_id).spam_check_test_status_id = '2'
          } else {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.not_campaign_active"),
              text: "",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33a2c",
              confirmButtonText: "Ok",
            })

            this.owarmList.list.find(item => item.owarm_id == owarm_id).spam_check_test_status_id = '1'
          }

        })
        .catch(error => {
          console.log('error', error)
        });
    },
    runManualTest(owarm_id){
      if(this.model.manualTestFields[owarm_id] == undefined || this.model.manualTestFields[owarm_id] == ''){
        return false;
      }
      adminService.spamCheckRunTest(owarm_id, this.model.manualTestFields[owarm_id])
        .then( result => {
          if (result == 'ok') {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.emailqueued"),
              text: "",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33a2c",
              confirmButtonText: "Ok",
            })
          } else {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.not_campaign_active"),
              text: "",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33a2c",
              confirmButtonText: "Ok",
            })
          }

        })
        .catch(error => {
          console.log('error', error)
        });

    },
    filter(event) {
      this.filters = event;
      //this.changePage(this.filters);
      this.search(this.filters);
    },
    goToClient(client_id) {
      // if(!this.hasPermissions('isAgencyManager') || this.hasPermissions('adminAgency')){
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      // }
    },
    goToTarget(target_id) {
      // if(!this.hasPermissions('isAgencyManager') || this.hasPermissions('adminAgency')){
        let url = "/orders/" + target_id;
        window.open(url, "_blank");
      // }
    },
    getOwarmStats(id) {
      this.accountSelected = false;
      this.model.from_owarm_id = undefined;
      if (id !== undefined) {
        let account = this.owarmList.list.filter((item) => item.id == id);
        this.accountSelected = account[0].email;
        this.model.from_owarm_id = parseInt(id);
      }
      this.loadOwarmStats = true;
      //this.multiaxisOwarm.datasets = [];
      adminService.getOwarmStats(this.model).then((result) => {
        this.owarmStats = result;
        // this.multiaxisOwarm.labels = this.owarmStats.labels;
        // this.owarmOptions.forEach((value, index) => {
        //   // this.multiaxisOwarm.datasets.push({
        //   //   type: value.type,
        //   //   label: value.label,
        //   //   hidden: false,
        //   //   borderColor: "RGBA(" + value.color + ",1)",
        //   //   backgroundColor: "RGBA(" + value.color + ",0.5)",
        //   //   pointBackgroundColor: "RGBA(" + value.color + ",1)",
        //   //   yAxisID: value.yAxisID,
        //   //   data: this.owarmStats[value.id],
        //   // });
        // });
        this.search();
        this.loadOwarmStats = false;
      });
    },

    changeSearch(warmup_system){// 1 warmy , 2 smartlead
      this.model.warmup_system = warmup_system;
      this.getOwarmStats();

      this.getTotal();
    },
    search(hasFilter = false) {
      this.changePage(hasFilter);
    },
    getTotal(){
      adminService.getOwarmListTotal(this.model).then((response) => {
        if (response !== undefined) {
          this.total = parseInt(response.total);
        }
      });
    },
    changePage(filters) {
      if (!this.model.filters) {
        this.model.filters = filters ? filters.filters : null;
      }
      this.loadingOwarmList = true;
      this.model.allItems = 0;

      adminService.getOwarmList(this.model).then((res) => {
        const { total, list, averages } = res;
        this.getTotal();       

        if (list.length > 0) {
          const listUpdated = list.map((el) => {
            let provider = "generic-icon.svg";

            if (el.provider == "ews") {
              provider = "outlook-icon.png";
            } else if (el.provider == "gmail") {
              provider = "gmail-new-icon.png";
            }
            const possibleValues = [0, 1, 2]; // quitar esta linea
            const randomIndex = Math.floor(Math.random() * possibleValues.length); // quitar esta linea
            return {
              ...el,
              provider: provider,
              // spam_check_test_status_id: String(randomIndex) // Quitar esta linea luego!!
            };
          });
          this.owarmList = {
            averages,
            total,
            list: listUpdated,
          };
        } else {
          this.owarmList = res;
        }
        this.loadingOwarmList = false;
        this.keyresult++;
      });
    },
    changeClientId(client_id) {
      this.model.client_id = parseInt(client_id);      
      this.getOwarmStats();
    },
    convertToPercentage(value) {
      return `${value * 20}%`;
    },
    getDataToCsv(){
      //const allItems = {allItems: 1, total: 0};
      this.model.allItems = 1;
      this.processingAllItems = true;
      adminService.getOwarmList(this.model).then((res) => {
        const { total, list, averages } = res;         

        if (list.length > 0) {
          const listUpdated = list.map((el) => {
            let provider = "generic-icon.svg";

            if (el.provider == "ews") {
              provider = "outlook-icon.png";
            } else if (el.provider == "gmail") {
              provider = "gmail-new-icon.png";
            }
            const possibleValues = [0, 1, 2]; // quitar esta linea
            const randomIndex = Math.floor(Math.random() * possibleValues.length); // quitar esta linea
            return {
              ...el,
              provider: provider,
              // spam_check_test_status_id: String(randomIndex) // Quitar esta linea luego!!
            };
          });
          this.owarmListAllItems = listUpdated
          this.download();
          this.processingAllItems = false
        } else {
          this.owarmListAllItems = [];
        }
        this.loadingOwarmList = false;
        this.keyresult++;
      });
    }
  },
};
</script>

<style>
.table-scroll-container {
  overflow-x: auto;
  max-width: 100%;
}
</style>
